<template>
  <b-card :title="$t('links')">
    <div v-for="(links, role) in roles" v-bind:key="links.name">
      <div v-if=userRoleCheck(role)>
        <label>{{ translateUserRoles(role) }}</label>
        <ul>
          <li v-bind:key="link.name" v-for="link in links">
            <a target="_blank" v-bind:href="link.url">{{ link.name }}</a>
          </li>
        </ul>
      </div>
    </div>
  </b-card>
</template>

<script>
  import BaseComponent from '../../components/BaseComponent'
  import {mapGetters} from 'vuex'
  import {isAdmin, isContentAdministrator, isCustomerAdministrator} from '@/services/PermissionService';

  export default {
    name: 'QuickLinks',
    extends: BaseComponent,

    data() {
      return {
        links: [],
        userRoles: []
      }
    },
    computed: {
      ...mapGetters('oidcStore', ['oidcUser']),
      roles() {
        return this.links.reduce((accumulator, link) => {
          if(link.role === null){
            // Admin link has no role constraint so adding null as role
            return accumulator['null'].push(link);
          }
          accumulator[link.role] = accumulator[link.role] || []
          accumulator[link.role].push(link)
          return accumulator
        }, Object.create({}))
      }
    },
    mounted() {
      this.links = this.config.quickLinks
      this.userRoles = this.oidcUser?.roles || []
    },
    methods: {
      userRoleCheck(role) {
        switch(role) {
          case 'openamadministrators':
            return isAdmin(this.oidcUser?.username);
          case 'useradministrators':
            return isCustomerAdministrator(this.oidcUser?.username);
          case 'contentadministrators':
            return isContentAdministrator(this.oidcUser?.username);
          case 'null':
            return true;
          default:
            return false;
        }
      }
    }
  }
</script>
